module.exports = __webpack_public_path__ + "res/Roboto-LightItalic-webfont.ttf?6710eed5eb424932557037822fa111b5";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-LightItalic-webfont.ttf
// module id = 74
// module chunks = 0